import React, { Component } from "react";

export default class CodeValueInput extends Component {
  render() {
    return (
      <div>
        <input
          className="CodeValueInput"
          ref={el => (this.input = el)}
          onChange={this.props.onChange}
          type="text"
          maxLength="1"
          value={this.props.value}
          pattern="[a-zA-Z0-9-]"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/CodeValueInput.js